const scopes = [
  {
    id: 'alimentacio',
    description: "Alimentació"
  },
  {
    id: 'cures',
    description: "Cures/Sanitari"
  },
  {
    id: 'educacio',
    description: "Educació"
  },
  {
    id: 'textil',
    description: "Tèxtil"
  },
  {
    id: 'reparacions',
    description: "Reparacions"
  },
  {
    id: 'tecnologia',
    description: "Tecnologia"
  },
  {
    id: 'assesoria',
    description: "Assesoria"
  },  
  {
    id: 'altres',
    description: "Altres"
  }
]

export { scopes }


// WEBPACK FOOTER //
// ./src/services/scope.service.js